import {always} from 'ramda';

const noop = always(undefined);

BX.namespace('Sale.OrderAjaxComponent');

BX.Sale.OrderAjaxComponent.sendRequest = noop;

export default BX.Sale.OrderAjaxComponent;
